var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"icon-tabs-list-item",class:{'icon-tabs-list-item_selected': _vm.getIsSelected},attrs:{"title":_vm.getGameName},on:{"click":_vm.selectFilter}},[_c('img',{attrs:{"src":_vm.getLogoUrl,"alt":"Not Found"}})])}
var staticRenderFns = []

export { render, staticRenderFns }